// Article content — 10 seed articles in Norwegian bokmål.

export const ARTICLES = [
  {
    slug: "botox-guide",
    title: "Alt du trenger å vite om botox i Norge",
    category: "Estetikk & Kosmetikk",
    readingTime: 7,
    date: "2025-01-15",
    excerpt: "En komplett guide til botox i Norge: priser, hva du bør sjekke, trygghet, og hva du kan forvente av behandlingen.",
    content: `Botox — eller botulinumtoksin — har de siste ti årene gått fra å være en nisjebehandling til en av de mest etterspurte estetiske prosedyrene i Norge. Men med den økte populariteten har også mytene og forvirringen vokst. Denne guiden går gjennom hva botox faktisk er, hvordan det fungerer, hva du bør se etter når du velger klinikk, og hva du realistisk kan forvente.

## Hva er botox?

Botox er et legemiddel fremstilt av botulinumtoksin type A. I små, kontrollerte doser brukes det til å midlertidig slappe av muskler. I estetisk sammenheng blir det injisert i små mengder i ansiktsmusklene som skaper mimikkrynker — typisk i panne, glabella (mellom øyenbrynene) og øyenkroker.

## Hvem kan utføre botox i Norge?

I Norge er det kun leger, tannleger og enkelte sykepleiere (under legens rekvisisjon) som lovlig kan injisere botulinumtoksin. Det betyr at hudpleiere, kosmetologer og andre ikke-medisinske behandlere ikke har lov til å utføre behandlingen. Dette er et viktig punkt: hvis du blir tilbudt botox utenfor en medisinsk setting, bør varsellampene blinke.

## Hva koster botox?

Prisene varierer mye — fra cirka 1 500 kr for ett område til 4 000+ kr for tre områder. I Oslo er gjennomsnittet for ett område rundt 2 500 kr. Se vår komplette prisguide for detaljerte priser per by.

## 7 ting du bør sjekke før du booker

1. Er behandleren lege, tannlege eller sykepleier?
2. Har klinikken dokumentert erfaring (bilder, anmeldelser)?
3. Får du en skikkelig konsultasjon før behandlingen?
4. Inkluderer prisen en etterkontroll etter 2 uker?
5. Hvilket produkt bruker de? (Allergan/Botox, Bocouture, Xeomin)
6. Har klinikken minst 4+ stjerner på Google eller Trustpilot?
7. Informeres du om bivirkninger og risiko skriftlig?

## Hva kan jeg forvente?

Effekten begynner å vises etter 3–5 dager, og er fullt utviklet etter 2 uker. Den varer typisk 3–4 måneder før musklene gradvis aktiveres igjen. De fleste gjentar behandlingen 2–3 ganger i året.

## Bivirkninger

De vanligste bivirkningene er midlertidige og milde: blåmerker ved injeksjonsstedet, lett hodepine eller asymmetri som går over i løpet av få uker. Alvorlige bivirkninger er svært sjeldne når behandlingen utføres av kvalifisert personell.

## Finn riktig spesialist

Specialists.no samarbeider kun med klinikker som har 4+ stjerner og sertifisert medisinsk personell. Fyll ut skjemaet — en klinikk kontakter deg innen 24 timer.`,
  },
  {
    slug: "fillers-guide",
    title: "Fillers: hva er det, hva koster det og hva bør du vite?",
    category: "Estetikk & Kosmetikk",
    readingTime: 8,
    date: "2025-01-20",
    excerpt: "Hyaluronsyre-fillers er trygt og mye brukt i Norge — men ikke alle fillers er like. Slik velger du riktig.",
    content: `Fillers er — sammen med botox — en av de mest etterspurte estetiske behandlingene i Norge. Men mens botox slapper av muskler, tilfører fillers volum der huden har mistet det. Denne guiden går gjennom alt fra produktvalg til priser, og hva du bør sjekke før du booker.

## Hva er fillers laget av?

De fleste moderne fillers er basert på hyaluronsyre — et stoff som finnes naturlig i kroppen og binder vann. Produkter som Juvederm, Restylane og Teosyal er hyaluronsyre-fillers, og de er fullt nedbrytbare. Det betyr at hvis du ikke er fornøyd, kan de oppløses med et enzym (hyaluronidase).

## Hva brukes fillers til?

- Leppeforming og -voluminisering
- Fylle ut nasolabialfurer ("smilerynker")
- Volumtap i kinn
- Kjevelinje-definering
- Håndforyngelse
- Underøye-hulhet (krever erfaren injektør)

## Hva koster fillers?

Priser per 1 ml (standard mengde for lepper):
- Oslo: 3 000–5 000 kr
- Utenfor Oslo: 2 500–4 500 kr

Prisen avhenger av produkt, mengde og behandlerens erfaring. Se vår prisguide for detaljer.

## Viktige sjekkpunkter

1. Kun medisinsk personell skal injisere fillers
2. Spør om produktnavn og CE-merking
3. Be om før/etter-bilder fra andre pasienter
4. Forsikre deg om at klinikken har hyaluronidase tilgjengelig
5. Still spørsmål om teknikk (kanyle vs. nål)
6. Unngå klinikker som gir umiddelbar rabatt eller presser deg

## Bivirkninger og risiko

De fleste opplever noe hevelse og ømhet de første 2–3 dagene. Alvorlige bivirkninger — som vaskulær okklusjon — er sjeldne, men alvorlige. Derfor er det avgjørende at behandleren kan håndtere komplikasjoner.

## Hvor lenge varer det?

- Lepper: 6–9 måneder
- Kinn og kjeve: 12–18 måneder
- Nasolabialfurer: 9–12 måneder`,
  },
  {
    slug: "hartransplantasjon-guide",
    title: "Hårtransplantasjon i Norge — komplett guide 2025",
    category: "Hår & Hodebunn",
    readingTime: 10,
    date: "2025-02-01",
    excerpt: "Hårtransplantasjon er en permanent løsning på hårtap — men hvor mye koster det i Norge, og er det bedre å reise til Tyrkia?",
    content: `Hårtransplantasjon er en av de raskest voksende behandlingene innen privat medisin i Norge. Med moderne FUE- og DHI-teknikker kan resultatene være nesten usynlige — men det er betydelige forskjeller mellom klinikker, teknikker og land. Denne guiden hjelper deg å forstå alternativene.

## Hva er hårtransplantasjon?

Ved hårtransplantasjon flyttes hårfollikler fra donorområdet (bakhodet, hvor håret er resistent mot DHT) til områder med tynt eller manglende hår. Følgende teknikker er vanligst:

- **FUE (Follicular Unit Extraction)**: Enkeltfollikler høstes med et lite instrument. Ingen synlige arr.
- **DHI (Direct Hair Implantation)**: Follikler implanteres med et Choi-pennelignende verktøy. Mer presis, dyrere.
- **Sapphire FUE**: Bruker safirblader for mer presise snitt, raskere tilheling.

## Hva koster det?

I Norge:
- 3 000 grafts: 40 000–55 000 kr
- 4 000 grafts: 55 000–75 000 kr
- 5 000 grafts: 75 000–100 000 kr

I Tyrkia:
- 3 000 grafts: 18 000–30 000 kr (inkl. reise, hotell)
- Ofte "alt inkludert"-pakker

## Norge vs. Tyrkia: hva bør du velge?

**Norge (pros):**
- Oppfølging er nær
- Språk og lovverk du forstår
- Ved komplikasjoner kan du enkelt kontakte klinikken

**Norge (cons):**
- 2–3 ganger dyrere

**Tyrkia (pros):**
- Lav pris
- Erfarne klinikker med høy volum

**Tyrkia (cons):**
- Kvalitetsforskjellen mellom klinikker er stor
- Oppfølging på avstand
- Dårlig oversettelse kan gi misforståelser

## 7 viktige sjekkpunkter

1. Ser du behandlerens navn eksplisitt? Eller bare "teamet vårt"?
2. Er klinikken godkjent av helsemyndighetene i landet?
3. Har de minst 4+ stjerner med flere hundre anmeldelser?
4. Får du en detaljert plan før operasjonen (antall grafts, teknikk)?
5. Inkluderer prisen oppfølging?
6. Hva er policy ved utilfredsstillende resultat?
7. Bilder av før/etter-resultater fra samme klinikk (ikke stockbilder)

## Tid og resultat

- Operasjonen tar 6–10 timer
- Tilbake på jobb: 3–7 dager
- Første resultat: 3 måneder
- Fullt resultat: 9–12 måneder
- Permanent: ja, med livsstils-hensyn`,
  },
  {
    slug: "privat-fysioterapi",
    title: "Slik finner du privat fysioterapi uten lang ventetid",
    category: "Fysioterapi & Kiropraktor",
    readingTime: 6,
    date: "2025-02-10",
    excerpt: "Ventetiden hos offentlig fysioterapi kan være lang. Slik kommer du raskt i gang privat — og hva det koster.",
    content: `Privat fysioterapi gir deg time innen 1–2 uker mot ofte 1–6 måneders ventetid hos kommunal fysioterapeut.

## Hvorfor velge privat?

- **Rask timeavtale**: Ofte innen 1–2 uker
- **Du velger behandler**: Velg spesialisering som passer (idrettsskader, manuell terapi, rehabilitering)
- **Fleksibilitet**: Kvelds- og helgeavtaler hos mange klinikker

## Hva koster privat fysioterapi?

- Oslo: 850–1 500 kr per time
- Utenfor Oslo: 800–1 300 kr per time

Mange klinikker tilbyr klippekort med rabatt.

## Får jeg refusjon?

- **Uten henvisning og driftstilskudd**: Nei
- **Med henvisning og driftstilskudd**: Ja — du betaler kun egenandel (men de har også ventetid)
- **Privat helseforsikring** dekker ofte fysioterapi i sin helhet

## Når bør jeg gå til fysioterapeut?

Vanlige grunner inkluderer:
- Akutte muskel- eller skjelettskader
- Kroniske smerter (rygg, nakke, skuldre)
- Etter operasjon eller idrettsskade
- Postural ubalanse
- Hodepine med muskulær årsak

## Slik velger du riktig

1. Sjekk at fysioterapeuten er autorisert (Helsepersonellregisteret)
2. Velg en med spesialisering relevant for ditt problem
3. Første time er en kartlegging — bruk den til å vurdere passform
4. Be om en behandlingsplan med tydelige mål`,
  },
  {
    slug: "invisalign-guide",
    title: "Invisalign vs tradisjonell tannregulering — hva bør du velge?",
    category: "Tannhelse & Smil",
    readingTime: 7,
    date: "2025-02-15",
    excerpt: "Usynlig tannregulering med Invisalign er populært — men det passer ikke alle. Her er forskjellene.",
    content: `Invisalign har revolusjonert voksen-tannregulering. I stedet for tradisjonelle braketter bruker du transparente, avtakbare skinnner som gradvis flytter tennene. Men er Invisalign alltid det beste valget? Her er forskjellene.

## Invisalign — fordeler

- Usynlig når du snakker og smiler
- Kan tas av ved måltider og tannpuss
- Ingen stikkende metallbraketter
- Færre akuttbesøk hos tannlegen

## Invisalign — ulemper

- Krever disiplin (må bæres 22 timer per dag)
- Dyrere enn noen tradisjonelle systemer
- Ikke egnet for alle komplekse tilfeller
- Rør må byttes hver 1–2 uker

## Tradisjonell regulering — når er det bedre?

For komplekse tilfeller — spesielt større feilstillinger, kjeveavvik eller tennverk — gir metallbraketter ofte bedre kontroll. Moderne keramiske braketter er dessuten mindre synlige enn før.

## Hva koster det?

- **Invisalign**: 35 000–70 000 kr i Norge
- **Tradisjonell**: 25 000–50 000 kr

Prisen varierer mye basert på kompleksitet og behandlingstid.

## Hvor lenge varer behandlingen?

- Lett korreksjon: 6–9 måneder
- Moderat: 12–18 måneder
- Kompleks: 18–24 måneder

## Refusjon fra HELFO

Voksne får vanligvis ingen refusjon med mindre det er medisinsk nødvendig (f.eks. kjeveleddsfunksjon). Barn og ungdom kan få dekning ved alvorlige feilstillinger.

## Finn en Invisalign-sertifisert tannlege

Ikke alle tannleger er sertifisert for Invisalign. Søk etter "Invisalign Platinum" eller "Diamond" providers for erfarne behandlere.`,
  },
  {
    slug: "oyenlaser-guide",
    title: "Øyenlaser i Norge: LASIK, LASEK og hva det koster",
    category: "Øye & Syn",
    readingTime: 8,
    date: "2025-02-22",
    excerpt: "Lei av briller og linser? Øyenlaser er en permanent løsning. Her er alt du bør vite før du bestiller.",
    content: `Over 30 000 nordmenn har tatt øyenlaser de siste ti årene. Teknologien har utviklet seg dramatisk — fra tidlige LASIK-inngrep til moderne SMILE og topografi-styrte prosedyrer. Men hva passer for deg?

## De tre hovedteknikkene

### LASIK
- Hornhinneflik lages, laser korrigerer, flik legges tilbake
- Hurtig rekonvalesens (1–2 dager)
- Passer ved moderat synsfeil

### LASEK / PRK
- Overflate behandles direkte, ingen flik
- Lenger rekonvalesens (5–7 dager)
- Tryggere ved tynn hornhinne eller aktiv livsstil

### ReLEx SMILE
- Minimalt inngrep, lite snitt
- Raskere rekonvalesens enn LASEK
- Ofte bedre for tørre øyne post-op

## Er jeg kandidat?

Vanlige krav:
- 18+ år, helst 21+
- Stabilt syn i minst 1 år
- Ingen alvorlig tørre øyne
- Tilstrekkelig hornhinnetykkelse
- Ingen aktive øyesykdommer

## Hva koster det?

- Per øye: 15 000–25 000 kr
- Pakker med garanti (2 øyne + 1 års oppfølging): 30 000–50 000 kr

De fleste klinikker tilbyr gratis forundersøkelse. Bruk den.

## Sjekkpunkter

1. Hvor mange operasjoner har klinikken utført? (helst tusener)
2. Hvilken teknologi bruker de? (Femto-LASIK er standard)
3. Er forundersøkelsen grundig (minst 60 min)?
4. Hva er policy ved behov for ny behandling (re-touch)?
5. Hvor lang garanti får du?

## Risiko og bivirkninger

- Tørre øyne (forbigående)
- Glorier rundt lys om natten
- I sjeldne tilfeller: permanent synsforstyrrelse

Med erfarne kirurger og moderne teknologi er komplikasjonsraten under 1 %.

## Etter operasjonen

- Tilbake på jobb (LASIK): 1–2 dager
- Bad og svømming: 2 uker
- Make-up rundt øyne: 1 uke
- Full stabilisering: 3–6 måneder`,
  },
  {
    slug: "privat-fysioterapi",
    title: "Privat fysioterapi — når er det verdt det?",
    category: "Fysisk Helse",
    readingTime: 6,
    date: "2025-03-01",
    excerpt: "Ventetiden hos offentlig fysioterapeut er lang. Her er når du bør velge privat, og hva det koster.",
    content: `Når ryggen verker eller skulderen låser seg, er ventetiden hos offentlig fysioterapeut ofte flere uker. For mange blir plagene verre i mellomtiden. Privat fysioterapi er et alternativ — men hvor mye koster det, og når er det egentlig verdt pengene?

## Forskjellen mellom offentlig og privat

- **Offentlig**: Med henvisning, egenandel, ofte 3–8 ukers ventetid
- **Privat**: Ingen henvisning nødvendig, time innen 1–3 dager, full pris

## Hva koster privat?

- 30 min: 500–800 kr
- 45 min: 800–1 100 kr
- 60 min: 1 000–1 300 kr

## Når er privat verdt det?

- Akutte plager som forverres ved venting
- Idrettsskader hvor tid til retur teller
- Kroniske plager hvor du vil bytte behandler
- Spesialiseringer som ikke er tilgjengelig offentlig (f.eks. vestibulær, bekkenbunn)

## Refusjon

Refusjon krever henvisning fra lege. Da kan du få dekning fra HELFO for inntil 24 behandlinger per år. Dette gjelder kun for fysioterapeuter med driftstilskudd.

## Slik finner du en god fysioterapeut

1. Sjekk autorisasjon på helsepersonellregisteret
2. Se etter spesialisering (manuell, ortopedi, idretts)
3. Les anmeldelser
4. Første time bør være grundig (45–60 min) med full kartlegging
5. Gode behandlere gir deg øvelser å gjøre hjemme

## Forbered deg

- Ta med relevante bilder/rapporter
- Beskriv plagen presist (når, hvordan, hva utløser)
- Vær klar for bevegelses-test`,
  },
  {
    slug: "estetisk-medisin-trygghet",
    title: "Estetisk medisin: hva er trygt og hva bør du unngå?",
    category: "Estetikk & Kosmetikk",
    readingTime: 9,
    date: "2025-03-08",
    excerpt: "Estetisk medisin er bransje i vekst — men ikke uten risiko. Her er de 10 viktigste tryggsmarkørene.",
    content: `Den estetiske medisinbransjen i Norge har vokst kraftig de siste fem årene. Men med veksten følger også aktører uten nødvendig kompetanse. Denne guiden hjelper deg å skille seriøse klinikker fra de du bør unngå.

## Lovverket i Norge

I 2019 strammet Helse- og omsorgsdepartementet reglene:
- Botox og fillers er reseptbelagte legemidler
- Kun leger, tannleger og enkelte sykepleiere kan injisere
- Behandlingen må skje i godkjente lokaler

Likevel finnes det fortsatt uoffisielle aktører — særlig via sosiale medier.

## De 10 tryggsmarkørene

1. **Medisinsk personell**: Behandleren er lege, tannlege eller autorisert sykepleier
2. **Åpne kvalifikasjoner**: Navnet på behandleren står eksplisitt
3. **Klinikklokaler**: Ikke privatbolig eller salonger
4. **CE-merket utstyr**: Produsentenes navn og batchnummer synlig
5. **Skriftlig konsultasjon**: Du får bivirkninger og risiko skriftlig
6. **Refleksjonstid**: Klinikken presser deg ikke til beslutning
7. **Anmeldelser**: 4+ stjerner på Google og Trustpilot, ikke bare Instagram
8. **Forsikring**: Klinikken har pasientskadeforsikring
9. **Oppfølging**: Etterkontroll er inkludert
10. **Aldersgrense**: 18+ år for estetiske inngrep

## Hva bør du unngå?

- "Botox-partier" i hjem eller salonger
- Tilbud som er for gode (f.eks. 50 % rabatt)
- Behandlere uten CV eller utdannelse-informasjon
- Klinikker som unngår skriftlige tilbud
- Pressende selgere som ringer tilbake

## Svartmarkedet

Dessverre selges injeksjonsprodukter ulovlig via sosiale medier og utenfor EU. Disse kan være:
- Forfalsket
- Feil oppbevart
- Utløpt

Aldri la noen injisere et produkt de har kjøpt på nettet.

## Hva gjør du ved komplikasjoner?

1. Kontakt klinikken umiddelbart
2. Ved alvorlige reaksjoner: oppsøk legevakt
3. Rapport til Statens Legemiddelverk
4. Vurder pasientskadeerstatning

## Vårt 4+ stjerner krav

Specialists.no godkjenner kun klinikker som:
- Har dokumentert medisinsk personell
- Minimum 4.0 stjerner på Google/Trustpilot
- Minst 50 anmeldelser
- Forpliktelse til 24-timers responstid`,
  },
  {
    slug: "velge-riktig-klinikk",
    title: "Slik velger du riktig klinikk — 7 ting du bør sjekke",
    category: "Estetikk & Kosmetikk",
    readingTime: 5,
    date: "2025-03-15",
    excerpt: "Med hundrevis av klinikker å velge mellom, hvordan skiller du de beste fra resten? Her er sjekklisten.",
    content: `Med hundrevis av private klinikker i Norge har du mange valg — men hvordan finner du den riktige? Her er de 7 tingene du alltid bør sjekke.

## 1. Kompetanse og kvalifikasjoner

Slå opp behandleren i Helsepersonellregisteret (helsedirektoratet.no). Der ser du autorisasjon og spesialisering. Hvis behandleren ikke finnes der, er det et alvorlig rødt flagg.

## 2. Erfaring med din spesifikke behandling

Generell medisinsk utdanning er ikke nok. Spør konkret:
- Hvor mange slike inngrep har du utført?
- Kan jeg se før/etter-bilder fra dine pasienter?
- Hvor ofte utfører du denne prosedyren?

## 3. Anmeldelser — og hvor de kommer fra

Google og Trustpilot er mest pålitelige. Instagram og Facebook er lettere å manipulere. Se etter minst 50+ anmeldelser og en snittvurdering på 4.0+.

## 4. Klare priser

Seriøse klinikker gir skriftlig tilbud med alle kostnader. Unngå klinikker som:
- Vil ikke oppgi pris før konsultasjon
- Endrer prisen i etterkant
- Legger til "overraskelser" som konsultasjonsgebyr

## 5. Grundig konsultasjon

Konsultasjonen bør inkludere:
- Medisinsk kartlegging
- Forventningsavklaring
- Bivirkninger og risiko skriftlig
- Refleksjonstid (du trenger ikke bestemme deg i rommet)

## 6. Oppfølging

Spør eksplisitt:
- Hva om jeg er misfornøyd?
- Er etterkontroll inkludert?
- Hvordan håndterer dere komplikasjoner?

## 7. Klinikkens forsikringsstatus

Alle seriøse klinikker har pasientskadeforsikring. Spør om det. Klinikker som nøler er en varselvinkel.

## Vår rolle

Specialists.no gjør denne kvalitetskontrollen for deg. Vi samarbeider kun med klinikker som oppfyller alle 7 kriteriene.`,
  },
  {
    slug: "privat-vs-offentlig",
    title: "Privat vs offentlig helsehjelp i Norge — hva er forskjellen?",
    category: "Fysisk Helse",
    readingTime: 7,
    date: "2025-03-22",
    excerpt: "Når bør du velge privat, og når er offentlig best? Her er de praktiske forskjellene.",
    content: `Norge har et av verdens beste offentlige helsevesen — men det betyr ikke at det er best for alt. Her er de praktiske forskjellene mellom privat og offentlig, og når du bør velge hva.

## Når offentlig er best

- **Akutt og alvorlig sykdom**: Skulle-operasjoner, kreft, traumer
- **Komplekse kirurgiske inngrep**: Hjerte, hjerne, transplantasjon
- **Kroniske sykdommer**: Tverrfaglig oppfølging
- **Barn**: Spesielt i lave-middelsrike familier

## Når privat er best

- **Ventetid**: Hvis plagen forverres ved venting
- **Valg av behandler**: Du får velge spesialist og tid
- **Kosmetisk og estetisk**: Ikke dekket av det offentlige
- **Mental helse**: Kort ventetid, spesialisering
- **Second opinion**: Rask vurdering fra annen lege

## Praktiske forskjeller

| Område | Offentlig | Privat |
| Kostnad | Egenandel + frikort | Full pris |
| Ventetid | 2 uker – 12 måneder | 1–3 uker |
| Valgfrihet | Begrenset | Full |
| Oppfølging | Koordinert | Separat |
| Kvalitet | Høy, standardisert | Varierer, ofte høyere komfort |

## Kan jeg kombinere?

Ja — mange gjør det. Eksempler:
- Offentlig utredning, privat oppfølging
- Privat fysioterapi, offentlig lege
- Privat konsultasjon, offentlig inngrep

## Forsikring

Helseforsikringer dekker:
- Rask tilgang hos privat spesialist
- Operasjon i privat klinikk innen 1–4 uker
- Fysioterapi og kiropraktor

Vanlige utbydere: Storebrand, Gjensidige, If, DNB.

## Hvordan finne riktig løsning

1. Er tilstanden akutt? Offentlig først
2. Er det kosmetisk eller ikke-medisinsk? Privat
3. Har du helseforsikring? Bruk den
4. Er ventetid et reelt problem? Vurder privat

Specialists.no hjelper deg finne private klinikker raskt — kun klinikker med 4+ stjerner.`,
  },
];

export const articleBySlug = (slug) => ARTICLES.find((a) => a.slug === slug);
export const relatedArticles = (slug, max = 3) => ARTICLES.filter((a) => a.slug !== slug).slice(0, max);
